<template>
    <div>
        <component :is="label ? 'label' : 'div'" class="flex" :class="[{ 'cursor-pointer': label }, boxClass]">
            <input
                :checked="checked"
                :class="[inputClass, 
                    { 
                        error: error !== false && hideErrorClass == false,
                        'input-checkbox': type == 'checkbox',
                        'input-radio': type == 'radio',
                    }
                ]"
                :disabled="disabled"
                :name="name"
                :value="value"
                class="cursor-pointer"
                :type="type"
                @blur="$emit('blur', $event)"
                @click="$emit('clicked', $event)"
                @focus="$emit('focus', $event)"
                @input="update"
            />

            <div class="select-none">
                <slot />
            </div>
        </component>

        <Error v-if="!hideError" :error="error">
            <template #errorAfter>
                <slot name="errorAfter" />
            </template>
        </Error>
    </div>
</template>

<script>
import Input from '~/mixins/input.js'

export default {
    mixins: [Input],

    props: {
        inputClass: { type: String, default: '' },
        checked: { type: Boolean, deafult: false },
        label: { type: Boolean, deafult: false },
        hideErrorClass: { type: Boolean, default: false },
        type: { type: String, default: 'checkbox' },
    },
}
</script>
